import type { CmsItem } from '@/utils/api'

export type Article = CmsItem<'/articles'>
export type GuideCategory = CmsItem<'/guide-categories'>
export type ArticleTag = CmsItem<'/article-tags'>

/**
 * Strapi's `meta.pagination`. Present at runtime on `/articles` but absent from
 * the generated OpenAPI types, so consumers read it through a narrow cast.
 */
export interface GuidePagination {
  page: number
  pageSize: number
  pageCount: number
  total: number
}

export const DEFAULT_PAGINATION: GuidePagination = {
  page: 1,
  pageSize: 9,
  pageCount: 1,
  total: 0
}

/** Number of articles shown in the "featured"/latest strip above the list. */
export const FEATURED_COUNT = 4
